import type { SVGProps } from "react";
import * as React from "react";

const SvgCheckedCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="35"
    height="35"
    viewBox="0 0 35 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clip-path="url(#clip0_7007_194418)">
      <path
        d="M29.6806 16.3866V17.5072C29.6791 20.1337 28.8286 22.6894 27.2559 24.7931C25.6832 26.8968 23.4727 28.4357 20.9539 29.1805C18.4352 29.9252 15.7432 29.8358 13.2794 28.9255C10.8156 28.0153 8.71205 26.333 7.28248 24.1296C5.85291 21.9261 5.1739 19.3196 5.34672 16.6988C5.51953 14.0779 6.53492 11.5831 8.24145 9.58652C9.94797 7.58989 12.2542 6.19838 14.8162 5.61954C17.3781 5.0407 20.0586 5.30553 22.4577 6.37453M29.6806 7.76317L17.5004 19.9555L13.8464 16.3014"
        stroke="#EA1B4B"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_7007_194418">
        <rect
          width="35"
          height="35"
          rx="4"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCheckedCircle;
